var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { NanolumensCaptivateBase } from './util/NanolumensCaptivateBase';
export class NanolumensCaptivateTcp extends NanolumensCaptivateBase {
    constructor(socket, state, log, framework) {
        super(NanolumensCaptivateTcp.driverType, state, log, framework);
        this.socket = socket;
    }
    // controls
    // phase callbacks
    // other class methods
    send(bytes, regExp, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.socket.send(AsciiText.decode(bytes), regExp, tags, options);
        });
    }
}
// static properties
NanolumensCaptivateTcp.driverType = 'socketDriver';
NanolumensCaptivateTcp.key = '-O3n3lvRiFMGscsNsuWp';
NanolumensCaptivateTcp.socketOptions = (config) => {
    var _a;
    return [
        {
            commandExtractor: (buffer) => {
                const regExLength = 38;
                const cmdRegEx = /(\x55{7}\xc0\x01\x03\x00\xd1\x01\xd0[\S\s]{2}\x00{2}\xff{17}\x00)([\S\s]{2})/;
                if (buffer.length >= regExLength + 1) {
                    for (let i = 0; i < buffer.length - regExLength; i++) {
                        const cmdToTest = buffer.slice(i);
                        const match = cmdRegEx.exec(cmdToTest);
                        if (match && match[1]) {
                            const dataLength = match[2].charCodeAt(0);
                            const cmdLength = match[1].length + 2 + dataLength + 1; // +2 for data length field, +1 for checksum
                            const command = `${match[1]}${match[2]}${cmdToTest.slice(match[1].length + 2, cmdLength)}`;
                            buffer = buffer.slice(cmdLength + i);
                            return { command, buffer };
                        }
                    }
                }
                return undefined;
            },
            sendTerminator: '',
            isBinary: true,
            port: (_a = config.port) !== null && _a !== void 0 ? _a : 4999,
        },
    ];
};
